export const GET_COMPANY_ANALYTICS_CHARTS_REQUEST =
  'GET_COMPANY_ANALYTICS_CHARTS_REQUEST';
export const GET_COMPANY_ANALYTICS_CHARTS_SUCCESS =
  'GET_COMPANY_ANALYTICS_CHARTS_SUCCESS';
export const GET_COMPANY_ANALYTICS_CHARTS_ERROR =
  'GET_COMPANY_ANALYTICS_CHARTS_ERROR';
